import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const ProductPriceDefaultProps = {
  ...ClassNameDefaultProps,
  context: null,
  discountPrice: null,
  invoiceUnit: null,
  label: null,
  price: null,
  showEmptyLabel: false,
  sup: false,
  weeeAmount: null,
};

export const ProductPricePropTypes = {
  ...ClassNamePropTypes,
  context: PropTypes.string,
  discountPrice: PropTypes.number,
  invoiceUnit: PropTypes.string,
  label: PropTypes.string,
  price: PropTypes.number,
  showEmptyLabel: PropTypes.bool,
  sup: PropTypes.bool,
  weeeAmount: PropTypes.number,
};
